// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";



// App Imports

import Box from "@mui/material/Box";
import CachedIcon from '@mui/icons-material/Cached';



// main function
export default function ReplaceContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    return (

        <Box>
            {(rowContractData.contractLevel === "X") &&
                <MenuItem>
                    <ListItemIcon>
                        <CachedIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Replace</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
